"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var dealerPageTitleStyles_1 = require("./dealerPageTitleStyles");
var Translation_1 = require("../../../../../common/components/presentation/Translation/Translation");
var DealerPageTitle = function () {
    var styles = dealerPageTitleStyles_1.default();
    return (<core_1.Box className={styles.titleContainer}>
      <core_1.Typography variant={'h4'} className={styles.title} data-test="text:dealer:pageTitle">
        <Translation_1.default id={'trans__checkout__dealers_page__page_title'}/>
      </core_1.Typography>
    </core_1.Box>);
};
exports.default = DealerPageTitle;
